import { OlympusClient } from '@/OlympusClient'
import type { HermesGuardFn } from '@/router/guards/types'

const PHONE_ORDERING_ROUTES = new Set([
  'brand.phone',
  'brand.phone.calls',
  'brand.phone.overview',
])

export const checkPhoneOrderingFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !PHONE_ORDERING_ROUTES.has(to.name)) {
    return undefined
  }

  const brandId = to.params.brandId
  const availabilityRequest =
    typeof brandId === 'string'
      ? {
          headers: { 'X-Active-Brand-ID': brandId },
          params: { brandId },
        }
      : null
  const result = availabilityRequest
    ? await OlympusClient.hestia.v1.brands.phone.getAvailability(
        availabilityRequest
      )
    : { rolloutEnabled: false }

  if (!result.rolloutEnabled) {
    return {
      name: 'brand.tools.phone-tree',
      params: { brandId },
    }
  }

  return undefined
}
